module.exports = __webpack_public_path__ + "static/media/question_icon_blue.81d3e251.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/question_bank/question_icon_blue.svg
// module id = 69
// module chunks = 0